export default __webpack_public_path__ + "static/media/6_long.650e38e0.svg";